import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Controls from "./Controls";
import HorizontalNavbar from "./HorizontalNavbar";
import VerticalNavbar from "./VerticalNavbar";
import { useAppContext } from "../../common/ApplicationServicesContext";

const Header = () => {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);
    const [translate] = useTranslation();
    const { domain } = useAppContext();

    const header = useMemo(() => {
        return (
            <>
                <header className="fixed-top navbar navbar-expand-lg navbar-dark bg-secondary">
                    <button className="navbar-toggler collapsed" onClick={() => setShowMenu(true)}>
                        <span icon="List" className="navbar-toggler-icon"></span>
                    </button>
                    <a className="navbar-brand" href="/" onClick={(event) => { event.preventDefault(); navigate("/") }}>
                        <img src="/logo.svg" className="logo" alt="Cœptis - by OnTheMove" />
                    </a>
                    <Controls />
                </header>

                <HorizontalNavbar />

                <Offcanvas show={showMenu} onHide={() => setShowMenu(false)} className="bg-light">
                    <Offcanvas.Header closeButton closeVariant="white" className="justify-content-between bg-secondary">
                        <label className="d-block h6 text-white">{`${translate("OTM_CONFIGURE")} - ${domain.name}`}</label>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <VerticalNavbar onSelectItem={() => { setShowMenu(false); }} />
                    </Offcanvas.Body>
                </Offcanvas>
            </>
        );
    }, [showMenu, navigate, translate, setShowMenu, domain.name]);

    return header;
};

export default Header;